import React from 'react';
import { useTranslation } from 'react-i18next';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton';
import { useEndSaleAction, useViewOffersAction } from '../../hooks';
const SellerButtons = ({ deviation, adoptableState: { canSellerViewOffers } })=>{
    const { t } = useTranslation();
    const sectionname = 'side-rail';
    const [onViewOffers, viewOffersBiData] = useViewOffersAction(deviation, {
        sectionname
    });
    const [onEndSale, endSaleBiData] = useEndSaleAction(deviation, {
        sectionname
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "end-sale",
        priority: "secondary",
        onClick: onEndSale,
        biData: endSaleBiData
    }, t('sidebar.exclusives.buttons.seller.endSale')), canSellerViewOffers && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "view-offers",
        priority: "primary",
        onClick: onViewOffers,
        biData: viewOffersBiData
    }, t('sidebar.exclusives.buttons.seller.viewOffers')));
};
SellerButtons.displayName = 'SellerButtons';
export default SellerButtons;
